import script from "./LiveCasinoGames.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveCasinoGames.vue?vue&type=script&setup=true&lang=js"

import "./LiveCasinoGames.vue?vue&type=style&index=0&id=0d1076f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d1076f2"]])

export default __exports__